import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

export type PillTone = 'neutral' | 'good' | 'warn' | 'bad' | 'info' | 'orange';

const tones: Record<PillTone, string> = {
  neutral: 'bg-bg2 text-ink2',
  good: 'bg-good-bg text-good',
  warn: 'bg-warn-bg text-warn',
  bad: 'bg-bad-bg text-bad',
  info: 'bg-info-bg text-info',
  orange: 'bg-orange-bg text-orange-ink',
};

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone | undefined;
}

/** Uppercase condensed pill used for statuses, roles and tags. */
export function Pill({ tone = 'neutral', className, ...rest }: PillProps) {
  return (
    <span
      className={cn(
        'inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-full px-2 font-cond text-[11px] font-bold uppercase tracking-wider [&>svg]:size-3',
        tones[tone],
        className,
      )}
      {...rest}
    />
  );
}
